import {
    FETCH_FEEDBACK,
    FETCH_FEEDBACKS,
    FETCH_EVTFEEDBACKS,
} from '../actions/feedback';


export const initialState = {
    isFetching: true,
    data: null
};

export const feedbacks = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_FEEDBACKS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_FEEDBACKS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const evtFeedbacks = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_EVTFEEDBACKS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_EVTFEEDBACKS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const feedback = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_FEEDBACK}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_FEEDBACK}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/feedback.js